export default __webpack_public_path__ + "static/media/Development-Skills_Laptop-with-code.a768f67b.jpg";